import { Component, Input} from '@angular/core';

@Component({
  selector: 'card-hdr',
  templateUrl: './card-hdr.component.html'
})
export class CardHdrComponent {

  @Input() title = '';
  @Input() src: string;
  @Input() height = 48;
  @Input() width  = 48;
}




// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/card-hdr/card-hdr.component.ts